import { render, staticRenderFns } from "./AgentSet.vue?vue&type=template&id=08826d10&scoped=true&"
import script from "./AgentSet.vue?vue&type=script&lang=js&"
export * from "./AgentSet.vue?vue&type=script&lang=js&"
import style0 from "./AgentSet.vue?vue&type=style&index=0&id=08826d10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08826d10",
  null
  
)

export default component.exports